module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gi-b4cbdc453e18fa88bcfefe48ca152a15.svg";